import demo from "./demoDatasets";

const translationDE = {
    common: {
        // This namespace could be used for general or common text variables that are used across different parts in the application.
        SelectButton: "Auswählen",
        LearnMoreButton: "Mehr erfahren",
        notFoundTitle: "Seite nicht gefunden.",
        notFoundDescription:
            "Die angefragte Seite konnte leider nicht gefunden werden.",
        Agree: "Ja",
        Disagree: "Nein",
        Warning: "Warnung",
        Deleted:"Gelöscht",
        clear:"Zurücksetzen",
        apply:"Anwenden",
        cancel:"Abbrechen"
    },


    //
    // COMPONENT-SPECIFIC NAMESPACES
    //

    language: {
        Name: "Deutsch",
    },

    analyzer: {
        Markers: "Marker",
        Scatter: "Scatter",
        Black: "schwarz",
        Dash: "gestrichelt",
        Line: "Linie",
        Actual: "Messwerte",
        Predicted: "Vorhersage",
        LabelTrainingSetPredictions: "Trainingsdatensatz Vorhersagen",
        LabelValidationSetPredictions: "Validationsdatensatz Vorhersagen",
        LabelTestingSetPredictions: "Testdatensatz Vorhersagen",
        LabelDottedLine:"Ideales Model (y=x)",
        LabelOptimalLine: "Optimale Line",
        LabelScatterPlot: "Vorhersage vs Messwerte",
        LabelAbsolutError: "Absoluter Fehler",
        LabelCRPS: "Prozentualer CRPS",
        LabelFeatureImportancePlot: "Feature Importance",
        LabelSHAPPlot: "SHAP (SHapley Additive exPlanations)",
        LabelNRMSE: "nRMSE",
        TrainingSet: "Trainingsdatensatz",
        ValidationSet: "Validationsdatensatz",
        TestSet: "Testdatensatz",
        runDataQuery: "runData ?",
        descriptionDeviation:
            "MAE = Mean Absolute Error \n nRMSE = Normalized Root Mean Squared Error",
        ScatterPlot: "Streudiagramm",
        DescriptionScatterPlot:
            "Diese Grafik zeigt, wie gut ein KI-Modell Werte vorhersagt. Die Vorhersagen des Modells werden als Punkte angezeigt. Die diagonale Linie stellt die ideale Vorhersage dar - wenn das Modell perfekt wäre, würden alle Punkte auf dieser Linie liegen. Je weiter die orangefarbenen Punkte von der Linie entfernt sind, desto ungenauer sind die Vorhersagen des Modells.",
        BoxPlot: "Box-Plot",
        DescriptionBoxPlot:
            'Der Box-Plot zeigt die Verteilung des absoluten prozentualen Fehlers auf dem Trainings- und Validations-Datensatz. Es enthält eine Box, die den Interquartilsabstand (IQR) der Fehler darstellt, sowie "Whiskers", die sich bis zu den minimalen und maximalen Werten innerhalb eines bestimmten Bereichs erstrecken. Das Diagramm enthält auch einzelne Punkte, die Ausreißerwerte darstellen. Diese Visualisierung ist nützlich, um die Streuung und zentrale Tendenz der Modellfehler zu verstehen und extreme Werte oder Trends zu identifizieren.',
        // Used
        PageTitle: "Analyse der Ergebnisse eines Experiment-Durchlaufs",
        SelectedRunDropdown: "Ausgewählter Durchlauf",
        SelectedTargetDropdown: "Ausgewählter Zielwert",
        DescriptionSelectRun:
            "Wählen Sie den Durchlauf aus, den Sie analysieren möchten.",
        SelectedPipelineStepDropdown: "Ausgewählter Pipeline Schritt",
        DescriptionFeatureImportance: "In diesem Feature Importance Plot wird die Wichtigkeit der Features für das KI-Modell dargestellt. Der Wert auf der X-Achse stellt die Wichtigkeit dar." +
                                       " Die Methode zur Ermittlung des Wichtigkeits-Werts, variiert je nach KI-Modelltyp. Die hier angewandte Wichtigkeits-Methode ist simpel und soll v.a. eine erste Einschätzung der Wichtigkeit der Features untereinander darstellen."+
                                        " Für Datensätze mit vielen Features ist diese Einschätzung nur bedingt aussagekräftig. Die Aussagekraft ist besonders dann eingeschränkt, wenn sich im Datensatz Features befinden, welche ähnliche Informationen enthalten. \n\n" +
                                       " Für eine genauere Einschätzung, welche Features für das KI-Modell wichtig sind, empfehlen wir ein 'Featureselektions'-Experiment durchzuführen. \n",
        DescriptionSHAP: "SHAP (SHapley Additive exPlanations)¹ ist eine Methode mit der die Erklärbarkeit von KI-Modellen verbessert werden kann. \n" +
            "SHAP stellt dar, wie sich Features auf das Target innerhalb des Modells auswirken. Dies ermöglicht ein besseres Verständnis der Vorhersagen des KI-Modells. \n \n" +
            "In diesem SHAP beeswarm Plot sind bis zu 15 Features dargestellt, welche im KI-Modell die größte Auswirkung auf das Target haben (nach der SHAP-Methode bzw. dem SHAP-Wert) . Die Reihenfolge auf der Y-Achse stellt den Auswirkungsgrad dar (von oben nach unten)." +
            " Auf der X-Achse, sind für jedes Feature die Validationssatz-Datenpunkte als Punkte dargestellt. Die Farbe der Punkte repräsentiert den Wert des Features und die Position der Punkte auf der X-Achse, repräsentiert den SHAP Wert, " +
            "d.h. die Auswirkung welche das Feature auf das Target hat.  Die Anzahl der Datenpunkte wird bei großen Datensätzen mit Hilfe von Sampling auf 1.000 reduziert.\n\n" +
            "¹ A Unified Approach to Interpreting Model Prediction, Lundberg et al., 2017",
        ReadMoreSHAPExplanation: "Erklärung des Beeswarm Plots (auf Englisch)",
        DatasetType: "Datensatztyp",
        NoExperiments:
            "Ihr aktuelles Experiment verfügt über keine trainierten Modelle, die verglichen werden können. \n Sie können eine ",
        NoExperiments_LinkText: "Trainings-Pipeline",
        NoExperiments_AfterLink: " starten, um ein trainiertes Modell zu erhalten.",
        AFSScatterTitle: "Übersicht Automatische Feature Selektion",
        AFSScatterDescriptionBody:
            "Bei der automatischen Feature Selektion (AFS) werden iterativ die Features rausgenommen,  welche am wenigsten Einfluss auf die Modell-Ausgabe haben. " +
            "Wie viel Features das sind, erfolgt zufällig. " +
            " Die dunkle Linie (Anzahl der selektierten Features) zeigt " +
            "                                               den Verlauf der AFS. \n Nach jeder AFS-Iteration wird das Modell getestet." +
            "                                               Der entsprechende Modell-Fehler " +
            "                                               hier Normalized Root Mean Squared Error) ist in der hellen Linie dargestellt. \n" +
            " Nach der AFS wird das Modell und die Feature-Auswahl mit dem geringsten Fehler und robustesten Verhalten behalten (grüner Punkt).",
        AFSHeatmap: "Selektierte Features über die Zeit",
        AFSHeatmapDescriptionBody:
        "Dieser Plot zeigt im Detail, welche Features in den Interationen (AFS Trainings) herausgenommen wurden. ",
        ConfusionMatrixValTitle: "Konfusionsmatrix Validations Set",
        ConfusionMatrixXTitle: "Vorhergesagte Klasse",
        ConfusionMatrixYTitle: "Wahre Klasse",
        ConfusionMatrixTrainTitle: "Konfusionsmatrix Trainings Set",
        ConfusionMatrixTestTitle:"Konfusionsmatrix Test Set",
        ConfusionMatrixColorBarLabel: "Anteil",
        ConfusionMatrixCaption: "Accuracy = Genauigkeit der KI-Modell Vorhersage",
        AccuracyTableValLabel: "Accuracy \n auf Validations Set",
        AccuracyTableTrainLabel: "Accuracy \n auf Trainings Set",
        AccuracyTableTestLabel:"Accuracy \n auf Testing Set",
        RegressionMetricTitle: "Fehlermaß",
        RegressionMetricTableValLabel: "auf Validations Set",
        RegressionMetricTableTrainLabel: "auf Trainings Set",
        RegressionMetricTableTestLabel: "auf Testing Set",
                GoToPipelineButton: "Zu der Trainings-Pipeline und den Hyperparameterplots",
        ForecastMean: "Mittelwert der Verteilung",
        ForecastMeanSectionHeadline: "Ergebnisse und Plots anhand des Mittelwerts der Verteilung",
        ErrorModelVisualizationHeadline: "Visualisierung Fehler-Modell + Original Modell",
        ErrorModelPlot: "Fehler-Modell Plot",
        ErrorModelScatterPlot: "Fehler-Modell Scatter-Plot",
        DescriptionErrorModelPlot:  "Dieser Plot veranschaulicht sowohl die Vorhersagequalität des Originalmodells als auch dessen Unsicherheit. " +
            "Die Unsicherheit wird durch das Fehler-Modell geschätzt und wird durch die Grenzwerte 3σ (99.7%) und 4σ (99.99%) angegeben. \n" +
            "Ist sich das Modell mit der eigenen Vorhersage sicher, liegen die Grenzwerte nahe zur Vorhersage. \n" +
            "Liegt die Messung außerhalb dieser Grenzwerte, wird eine Warnung oder eine Alarmmeldung angezeigt. \n",
        DescriptionErrorModelScatterPlot: "Dieser Plot ist eine Erweiterung des klassischen Scatter Plots. Er  veranschaulicht zusätzlich die Prädiktions-Unsicherheit. " +
            "Die Unsicherheit wird durch das Fehler-Modell geschätzt und wird durch die Grenzwerte 3σ (99.7%) und 4σ (99.99%) angegeben. \n" +
            "Liegt die Messung außerhalb dieser Grenzwerte, wird eine Warnung oder eine Alarmmeldung angezeigt. \n",
        DeleteRunButton: "Training löschen",
        DownloadModelButton: "Modell herunterladen",
        DownloadOptions: "Download Optionen",
        DownloadModelDescription: "Standardmäßig werden ein Modell im ONNX-Format, die Liste der konfigurierten Datentransformationen sowie ein Python-Skript heruntergeladen.\n\n " +
            "Zusätzlich können hier Daten und Ausführungsumgebungen für den Download ausgewählt werden.",
        DataDownload: "Daten herunterladen",
        IncludeValidation: "Validationsdaten herunterladen",
        IncludeTrainData: "Trainingsdaten herunterladen",
        AdvancedDataDownload: "🛠️ Unaufgeteilte Daten herunterladen",
        IncludeOriginalData: "Originaldaten herunterladen",
        IncludeSplitData: "Aufteilungsmatrix der Originaldaten herunterladen",
        Warning: "⚠️ Nur falls kein Conda vorhanden, env.yaml ist beim Standard-Download enthalten und der empfohlene Installationsweg",
        IncludeWindows: "Windows Python Umgebung herunterladen",
        IncludeLinux: "Linux Python Umgebung herunterladen",
        Cancel: "Abbrechen",
        CreatingDownloadZip: "Download ZIP-Datei wird erstellt...",
        CloseWindow: "Fenster schließen",
        ConfusionMatrixDescriptionTitle: "Konfusionsmatrix",
        ConfusionMatrixDescriptionBody:
            "Die Konfusionsmatrix ist eine Methode zur Bewertung der Vorhersagequalität eines Klassifikationsmodells." +
            "                                               Die Tabelle gibt an wie gut ein Modell die einzelnen Klassen vorhersagt. \n" +
            "                                               Sie zeigt wie groß der Anteil richtig und falsch zugeordneter Vorhersagen" +
            "                                               für jede Klasse ist, indem die vorhergesagten mit den tatsächlichen Klassen" +
            "                                               für jede Eingabe miteinander ins Verhältnis gesetzt werden. \n" +
            "                                               Die Matrix dient dabei auch als Berechnungsgrundlage für weitere quantitativer \n" +
            "                                               Metriken wie zum Beispiel der Accuracy (Genauigkeit). ",
        DescriptionDataBalancing:"Hier wird die ursprüngliche Zielwertverteilung (rot) mit der Zielwertverteilung nach dem Balancing (grün) veranschaulicht. \n" +
        "Die balancierten Daten werden nur für das Training des Modells verwendet.",
        DataBalancingTitle:"Data Balancing Plot",
        DataBalancingPlotTitle:"Data Balancing Plot",
        DataBalancingPlotXTitle:"Häufigkeitsverteilung der Zielwerte",
        DataBalancingPlotYTitle:"Zielwert",
        LabelErrorModelPlot: "Fehler-Modell Plot"
    },
    currentExperimentSelector: {
        CurrentDatasetDropdown: "Aktueller Datensatz",
        NoDataset: "Noch kein Datensatz erstellt",
        AddDatasetButton: "Neuen Datensatz hinzufügen",
        CurrentExperimentDropdown: "Aktuelles Experiment",
        NoExperiment: "Noch kein Experiment erstellt",
        AddExperimentButton: "Neues Experiment hinzufügen",
    },

    datasetConfigurator: {
        DatasetNameFillable: "Anzeigename des Datensatzes",
        HintDatasetName: "Der Name dient der Übersicht und ist frei wählbar",
        FileSettingsTitle: "Dateieinstellungen",
        CSVEncodingDropdown: "CSV-Kodierung",
        HintEncoding: "Benötigt um Formatierungsprobleme zu vermeiden", // TBD
        CSVDelimiterDropdown: "CSV-Trennzeichen",
        HintDelimiter:
            "Das Trennzeichen trennt Datenfelder voneinander in Ihrer CSV-Datei", // TBD
        DatasetSettingsTitle: "Datensatzeinstellungen",
        HintDatasetSettings:
            "Optionen um eigene Validierungs- und Testdatensätze zu verwenden",
        UseCustomVal: "Benutzerdefinierten Trainings/Validations-Split verwenden",
        UseTest: "Testdatensatz verwenden",
        TablePreviewTitle: "Tabellenvorschau",
        TableDescription1: "Erste Zeilen Ihrer hochgeladenen Daten",
        TableDescription2: "Spalten ",
        TableDescription3: "Zeilen",

        ErrorDemoDatasetAlreadyExists:
            "Sie haben diesen Datensatz bereits erstellt. Falls Sie ein Experiment dazu anlegen wollen, \n wählen Sie den Datensatz im Dropdown Menü aus und klicken Sie auf ➕.",
    },

    datasetCreator: {
        UploadDataButton: "Daten hochladen",
        UploadInProgress: "Daten werden hochgeladen...",
        ConfigureCheckButton: "Daten konfigurieren & prüfen",
        DatasetCreatedButton: "Datensatz erstellt",
        CreateDatasetError: "Fehler beim Erstellen des Datensatzes ",
        FailedUploadError: "Fehler beim Hochladen der Daten ",
        DatasetCreationInProgress: "Datensatz wird erstellt...",
        DatasetCreated_1: "Datensatz ",
        DatasetCreated_2: " erstellt",
        DatasetCreated_3: "Ein neuer Datensatz mit dem Namen ",
        DatasetCreated_4: " wurde erfolgreich erstellt.",
        BackButton: "Zurück",
        StartCreationButton: "Erstellung des Datensatzes starten",
        CreateSplitsTitle:"Benutzerdefinierten Validationsdatensatz hochladen für: {{datasetName}}",
        StartCreationButtonAndUseVal: "Weiter zum Validations-Split Upload",
        SplitDataUploadButton:"Datensatz-Split hochladen",
    },

    datasetError: {
        MissingColumnValues: "Nicht alle Spalten haben einen Namen",
        TooManyRows: "Der Datensatz enthält zu viele Reihen. Es sind maximal 1 000 000 Reihen erlaubt, aber nur {{max_rows, number}} sind enthalten",
        TooFewRows: "Der Datensatz enthält nicht genug Reihen. Es werden minimum 20 Reihen benötigt, aber nur {{min_rows, number}} sind enthalten",
        TooManyColumns: "Der Datensatz enthält zu viele Spalten. Es sind maximal 10 000 Spalten erlaubt, aber nur {{max_columns, number}} sind enthalten",
        TooFewColumns: "Der Datensatz enthält nicht genug Spalten. Es werden minimum 3 Spalten benötigt, aber nur {{min_columns, number}} sind enthalten",
        FileSizeTooBig: "Der Datensatz ist mit ~{{fileSize, number}}MB zu groß. Die maximal erlaubte Größe ist 5000MB",
        ColumnNamesTooLong: "Bitte beachten Sie, dass einige Spaltennamen die empfohlene maximale Zeichenlänge von 24 überschreiten. Diese Begrenzung dient dazu, eine ordnungsgemäße Anzeige der Informationen sicherzustellen. Sie können diese Spalten in der unten stehenden Liste umbenennen",
        DatasetNameAlreadyExists:"Ein Datensatz mit diesem Namen existiert bereits. Bitte wählen Sie einen anderen Namen.",
    },

    datasetAbortUpload: {
        Warning: "Sie sind dabei den Upload abzubrechen. Wollen Sie fortfahren?"
    },

    datasetEditor: {
        ColumnNamesTooLongWarning: "Überlange Spaltennamen",
    },

    examples: {
        PageTitle: "Beispiel-Experimente",
        ButtonSelectExampleDataset: "Beispiel-Datensatz auswählen",
        Difficulty: "Experiment-Schwierigkeitsgrad",
        DatasetInformation: "Datensatzinformationen",
        NumDatapoints: "Anzahl der Datenpunkte",
        NumFeatures: "Anzahl der Eingangsdaten (Features)",
        TargetDescription: "Zielwert(e)",
        Automatically:
            "\n Mit dem AutoML Tool wurden automatisch folgende Schritte durchgeführt:",
        Step1: "1. Vorverarbeitung des Datensatzes",
        Step2:
            "2. Training eines Regressionsmodells mit automatischer Hyperparameterabstimmung",
        Step3:
            "3. Training eines Fehlerschätzmodells, das die Unsicherheit des trainierten Regressionsmodells vorhersagt",
        Step4: "4. Generierung von Plots zur Modellbewertung",
        Step5: "5. Bereitstellung eines herunterladbaren und ausführbaren Modells",
        ButtonImportExample: "Beispiel-Datensatz importieren und anzeigen",
        // Example 1
        TitleExample1: "Erkennung von Ausreißern im Temperatursensor",
        DatasetFileNameExample1: "",
        TeaserImageUrlExample1:
            "https://images.pexels.com/photos/6434745/pexels-photo-6434745.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        DescriptionExample1:
            "\n Das zu lösende Problem besteht darin, abnormale Messwerte eines Temperatursensors zu identifizieren, die auf eine Fehlfunktion oder andere Probleme hinweisen könnten.",
        DifficultyRatingExample1: 2,
        NumDatapointsExample1: 802,
        NumFeaturesExample1: 13,
        TargetsExample1: "Messwert des Temperatursensors",
        OutcomeExample1:
            "\nDas Ergebnis dieses Experiments ist ein KI-Modell, das Ausreißer mit einer Erkennungsrate von 97% identifizieren kann. Dies ist eine äußerst genaue und zuverlässige Methode zur Identifizierung abnormer Messwerte aus den Sensor-Daten und kann wertvolle Erkenntnisse liefern, um Fehlfunktionen oder andere Probleme zu erkennen.",
        FeaturesExample1:
            "4 (Tag im Jahr, Stunde des Tages, Windgeschwindigkeit, Druck, Luftfeuchtigkeit)",
        // Example 2
        TitleExample2:
            "Tagesvorhersage von Erzeugnissen einer Photovoltaik-Dachanlage",
        DatasetFileNameExample2: "☀️ Photovoltaik",
        TeaserImageUrlExample2:
            "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        DescriptionExample2:
            "\nBeispieldatensatz einer KI-Anwendung für eine Photovoltaik-Dachanlage. Mit Hilfe eines KI-Modells soll die Produktion der kommenden 24h anhand von Wettervorhersagedaten vorausgesagt werden.",
        TargetsExample2: "24h-Gesamtproduktion in Wattstunden",
        DifficultyRatingExample2: 4,
        NumDatapointsExample2: 1977,
        FeaturesExample2: "9 (z.B. Defuse Strahlung, Direkte Strahlung, ...)",
        OutcomeExample2:
            "\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.",
        // Example 3
        TitleExample3: "Ermittlung der Milchqualität",
        DatasetFileNameExample3: "🐄 Milch Qualität",
        TeaserImageUrlExample3:
            "https://images.pexels.com/photos/3214973/pexels-photo-3214973.jpeg",
        DescriptionExample3:
            "\nBeispieldatensatz für eine KI-Anwendung im Molkereibetrieb. Anhand von Messdaten einzelner Milchproben soll mit Hilfe von KI-Modellen die Güteklasse der Milch bestimmt werden.",
        DifficultyRatingExample3: 1,
        NumDatapointsExample3: 200,
        FeaturesExample3: "6 (z.B. pH Wert, Temperatur, Farbe, ...)",
        TargetsExample3: "Güteklasse der Milch: 0, 1, 2",
        OutcomeExample3: "\n",
        // Example 4
        TitleExample4: "Ermittlung der Beton Druckfestigkeit",
        DatasetFileNameExample4: "🏗️ Beton Druckfestigkeit",
        TeaserImageUrlExample4:
            "https://images.pexels.com/photos/2628393/pexels-photo-2628393.jpeg?auto=compress&cs=tinysrgb&w=1600",
        DescriptionExample4:
            "\nBeispieldatensatz für eine KI-Anwendung aus der Beton-Herstellung. Die Druckfestigkeit des Betons soll anhand der Mischkomponenten ermittelt werden. Zusätzlich soll durch die Feature-Importance ein neuer Einblick geschaffen werden, welche Eingangsdaten den größten Einfluss auf die Druckfestigkeit haben.",
        DifficultyRatingExample4: 2,
        NumDatapointsExample4: 5407,
        NumFeaturesExample4: 8,
        FeaturesExample4: "8 (z.B. Hochofenschlacke, Flugasche, Fließmittel, ...)",
        TargetsExample4: "Druckfestigkeit in MPa",
        OutcomeExample4:
            "\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.",
        // Example 5
        TitleExample5:
            "24h Vorhersage von Erzeugnissen einer Photovoltaik-Dachanlage ⚠️ mit ungeeigneten Daten",
        DatasetFileNameExample5: "☀️ Photovoltaik (ungeeignet)",
        TeaserImageUrlExample5:
            "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        DescriptionExample5:
            "\nBeispieldatensatz einer KI-Anwendung für eine Photovoltaik-Dachanlage. Mit Hilfe eines KI-Modells soll die Produktion der kommenden 24h anhand von Wettervorhersagedaten vorausgesagt werden. \n ⚠️ Von diesem Datenset hat es zwei Versionen, dies ist die Version mit ungeeigneten Daten.",
        TargetsExample5: "Solarerzeugung in Wh",
        DifficultyRatingExample5: 4,
        NumDatapointsExample5: 1518,
        FeaturesExample5: "9 (z.B. Defuse Strahlung, Direkte Strahlung, ...)",
        OutcomeExample5:
            "\nLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.",
    },

    experimentConfigurator: {
        PageTitle_1: "Erstellen Sie ein",
        PageTitle_2: " Experiment für ",
        TargetTitle: "Zielwert-Einstellungen (Targets) ",
        TargetDescription: "Welche Spalten möchten Sie vorhersagen?",
        TargetDescriptionClassification:"Wählen Sie den Zielwert aus, den Sie vorhersagen möchten. Für Klassifikationsexperimente können Sie nur ein Target auswählen.",
        TargetDropdown: "Zielwert-Spalte(n)",
        HintTarget: "Wählen Sie das Zielattribut, das Sie vorhersagen möchten", // TBD
        FeatureTitle: "Eingangsdaten-Einstellungen (Features)",
        FeatureDescription:
            "Standardmäßig werden alle Nicht-Zielwert-Spalten als Eingangsdaten (Features) behandelt. Hier können Sie einige Änderungen vornehmen.",
        IgnoreDropdown: "Ignorierte Spalte(n)",
        HintIgnore:
            "Wählen Sie die Spalten aus, die für das Modelltraining ignoriert werden sollen (optional)", // TBD
        IdDropdown: "ID-Spalte",
        NoID: "Keine ID-Spalte",
        HintID:
            "Wählen Sie die Spalte, die die eindeutigen IDs für die Datensätze enthält (optional)", // TBD
        TimestampDropdown: "Zeitstempel-Spalte",
        NoTimestamp: "Keine Zeitstempel-Spalte",
        HintTime:
            "Wählen Sie die Spalte, die die Zeitstempel für die Datensätze enthält (optional)", // TBD
        ExperimentSettingsTitle: "Experiment-Einstellungen",
        ExperimentSettingsDescription: "Zusätzliche Einstellungen",
        ExperimentNameFillable: "Angezeigter Experiment-Name",
        HintExperimentName: "Der Name dient der Übersicht und ist frei wählbar", // TBD
        ExperimentCommentsFillable: "Ihr Kommentar zum Experiment",
        HintExperimentComments: "Ihre zusätzlichen Kommentare", // TBD
        NoComment: "Kein Kommentar",
        TimestampTitle: "Zeitstempel",
        FeaturePreviewTitle: "Eingangsdaten-Vorschau",
        ExplainFeaturesTable: "Erste Zeilen Ihrer Eingangsdaten-Daten",
        NoFeatures: "Keine Eingangsdaten-Spalten ausgewählt",
        TargetPreviewTitle: "Zielwert-Vorschau",
        ExplainTargetTable: "Erste Zeilen Ihrer Zielwert-Daten",
        NoTarget: "Noch keine Zielwert-Spalten ausgewählt",
        SaveAndProcessButton: "Einstellungen speichern & Datenverarbeitung starten",
        SuccessExperimentProcessingStarted: "Experiment erfolgreich gestartet.",
        HintNoDatasetYet:
            "Sie haben noch keinen Datensatz hochgeladen mit dem ein Experiment erstellt werden könnte. Bitte laden Sie zuerst einen Datensatz hoch.",
        ErrorExperimentAlreadyExists:
            "Ein Experiment mit diesem Namen existiert bereits  \n für diesen Datensatz. Bitte wählen Sie einen anderen Namen.",
        ErrorTargetDoesNotMatchExperimentType:
            "Ihr aktueller Datensatz ist nicht für den von Ihnen gewählten Zielwert und/oder Experimenttyp geeignet. \n  Wählen Sie einen anderen Zielwert und/oder Experimenttyp.",
        "Error undefined": "",
        "Error Target column is not set correctly.":
            "Zielwert(e) sind nicht korrekt gesetzt",
        "Error Timestamp column is not set correctly.":
            "Zeitstempel Spalte ist nicht korrekt gesetzt",
        "Error Id column is not set correctly.":
            "Id Spalte ist nicht korrekt gesetzt",
        "Error Ignored column is not set correctly.":
            "Ignorierte Spalten sind nicht korrekt gesetzt",
        "Error Experiment name already exists.":
            "Ein Experiment mit diesem Namen existiert bereits für diesen Datensatz.",
        TimestampRequiredForForecast: "Für Prognose-Experimente ist ein Zeitstempel erforderlich",
        CheckboxSameDistributionLabel:"Die Zielwerte kommen aus derselben Verteilung",
        SplitFileDropdown: "Split-Datei auswählen",
        SplitDataTitle: "(Optional) Split-Konfiguration",
        UseDefaultSplit: "Standardaufteilung wählen",
        DefaultSplitHelperText: "Das AutoML-Tool teilt die Daten automatisch in Trainings- und Validierungssätze auf.",
        AddSplitDataButton: "Split-Datei hinzufügen",
        AddSplit: "Split hinzufügen",
        CustomSplitHelperText: "Placeholder",
        OriginalSelector: "Selektor ändern",
        MultiSelector:"Selektor ändern",
        TargetSelectorHint:"Placeholder",
        IgnoreColumnSelectorHint:"Placeholder",
        SplitDataDescription:"Hier kann der Trainings- und Validations-Split angepasst werden",
        SplitMethodDropdown: "Split Methode",
        SplitMethodPlaceholder: "Split Methode auswählen",
        SplitMethodPlaceholderHelper:"Wählen Sie optional eine Methode zur Aufteilung der Daten in Trainings- und Validationssätze",
        SplitMethodKILab: "KI-Lab Split Methode",
        SplitMethodCustom: "Eigene Split Datei",
        SplitMethodKILabHelper:"Der Datensatz wird abhänging von zwei Parametern aufgeteilt",
        SplitMethodCustomHelper:"Laden Sie eine eigene Split-Maske hoch",
        CustomSplitDialogTitle: "Split-Datei Konfiguration",
        KILabSplitDialogTitle: "Einstellungen",
        ValidationRatioLabel: "Anteil Validationsset",
        ValidationRatioHelper: "Die Anzahl der Trainingsdaten ergeben sich aus den restlichen Daten",
        ValSplitIndexLabel: "(Optionaler Parameter) Index des ersten Validations-Blocks",
        ValSplitIndexHelper:"Dieser Parameter ist nur notwendig, wenn zusätzliche eine k-Fold Cross Validation angewendet wird (erfordert mehrere Experimente)",
        SplitPreviewTitle: "Visualisierung des Trainings- und Validations-Splits",
        SplitPreviewDescription: "Zu sehen ist die Aufteilung des Datensatzes in Trainings- und Validationsdaten. Zunächst werden alle Daten in 200 Blöcke geteilt. \n" +
        "Wie viele Blöcke davon Validationsdaten sind, ergibt sich aus dem 'Anteil' Parameter. Zu empfehlen ist maximal jeder 5. Block (20%) und minimal jeder 7. Block (14%). \n" +
        "Zusätzlich gibt der Iterations-Parameter an, mit welchem Block Validation gestartet ist (Default ist Block 0, d.h. der Erste).",
        SplitLegendTrain: "Trainingsdaten",
        SplitLegendValidation: "Validationsdaten",
        SplitLegendTest: "Testset",
        TrainedModelRequired: "Für Fehlermodell-Experimente ist ein trainiertes Modell erforderlich. Bitte wählen Sie einen anderen Datensatz auf der Seite ",
        ExperimentSelection: "Experiment auswählen",
        HintExperiment: "Wählen Sie das Experiment, auf dem das Fehlermodell basieren soll",
        RunSelection: "Trainingslauf auswählen",
        HintRun: "Wählen Sie den Trainingslauf aus, auf dem das Fehlermodell basieren soll",
    },

    experimentErrors: {
        FailedCreationError: "Fehler beim Erstellen des Experiments",
        ExperimentNameAlreadyExists: "Ein Experiment mit diesem Namen existiert bereits",
        ExperimentTargetTypeInvalid: "Die Werte folgender Zielspalten '{{target_columns, list}}' sind nicht numerisch oder enthalten NaNs. Nicht numerische Werten werden aktuell noch nicht unterstützt",
        ExperimentTargetNotUnique: "Die Werte einer oder mehrerer ausgewählten Zielspalten sind nicht eindeutig",
        ExperimentTimestampInvalid: "Der ausgewählte Zeitstempel ist nicht gültig",
        ExperimentIDNotUnique: "Die ausgewählte ID Spalte ist nicht eindeutig",
        ExperimentIDInvalidType: "Der ausgewählte ID Typ '{{type,list}}' wird nicht unterstützt: Nur 'int64' und 'object' sind erlaubt ",
        FailedDeletion: "Die ausgewählten Experimente konnten nicht gelöscht werden",
        ExperimentTimestampNotContinuous:"Der ausgewählte Zeitstempel ist nicht kontinuierlich. Für Prognose-Experimente muss der Zeitstempel fortlaufend sein."
    },

    experimentRoutes: {
        MissingExperiment_1: "Ein Experiment mit dem Namen",
        MissingExperiment_2:
            "konnte für Ihren aktuellen Datensatz nicht gefunden werden.",
        MissingDataset_1: "Ein Datensatz mit dem Namen",
        MissingDataset_2: "konnte nicht gefunden werden.",
    },

    experimentTypeSelector: {
        PageTitle: "Erstellen Sie ein Experiment für Ihren Datensatz",
        PageInstructions: "Wählen Sie die Art der Aufgabe für Ihr Experiment aus:",
        CreateExperimentButton: "Experiment erstellen",
        ClassificationTitle: "Klassifikation",
        ClassificationDescription:
             "Klassifikation beschreibt einen Technik des Maschinellen Lernens. "+
            "                                   Bei der Klassifikation wird eine Reihe von Eingabedaten (Features) dazu verwendet"+
            "                                   diese einer bestimmten Klasse (Label) zuzuordnen. Die Zuordnung geschieht dabei durch " +
            "                                   die Anwendung eines Algorithmus aus dem Bereich des Überwachten Lernens. Das Ziel des" +
            "                                   Modells ist es dabei die Beziehung zwischen Eingabedaten und den Klassen so abzubilden, " +
            "                                   dass es in der Lage ist die Klasse für neue, noch nicht gesehene Eingaben zu bestimmen. " +
            "                                   Die Anzahl der Klassen sowie die eindeutige Zuordnung aller Daten zu jeweils einer Klasse müssen " +
            "                                   dabei im Trainingsdatensatz gegeben sein, um ein Modell trainieren zu können.\n\n"+
            "",
        RegressionTitle: "Regression",
        ExperimentNameStart: "My ",
        ExperimentNameEnd: " Experiment",
        RegressionDescription:
           "Die Regression ist eine Art des überwachten Lernens und hat das Ziel eine abhängige " +
            "                                   Variable auf der Basis einer oder mehrerer unabhängiger Variablen vorherzusagen. " +
            "                                   Es wird also ein Modell erstellt, welches in der Lage ist, die " +
            "                                   zugrunde liegende Beziehung zwischen Eingabemerkmalen und der Ausgabe abzubilden "+
            "                                   und so Vorhersagen zu treffen. Die Grundidee ist dabei, die beste Anpassungslinie " +
            "                                   oder -kurve zu finden, die die Beziehungen zwischen den Variablen in den Daten " +
            "                                   darstellen kann. Dabei können sowohl kontinuierliche als auch kategoriale Variablen als Eingabe verwendet werden.\n\n"+
            "",
        ForecastTitle: "Probabilistische Prognose",
        ForecastDescription:
            "️⚠️⚠️⚠️ This Implementation is WIP: Please ask Ina first, whether your data is suitable 😬.  Bei der Prognose werden bestimmte Algorithmen des maschinellen Lernens verwendet, um zukünftige Ereignisse oder Ergebnisse auf der Grundlage historischer Daten vorherzusagen. Die Prognose ist eine spezielle Form der Regression mit dem Fokus vergangene Muster zu berücksichtigen, um Aussagen über die Zukunft zu treffen. Darüber hinaus wird in diesem Experimenttyp auch die Unsicherheit der Vorhersage angeben.",
        ErrorModelTitle: "Fehlermodell (Error Model)",
        ErrorModelDescription:
            "Dieser Experimenttyp kann verwendet werden, um ein Fehlermodell auf der Grundlage eines vorhandenen trainierten Modells zu erstellen. Ein Fehlermodell kann Erkenntnisse über die Unsicherheit der Vorhersage des ursprünglichen Modells liefern.",
        NotSureTitle: "Nicht sicher, welche Art von Aufgabe Sie benötigen?",
        NotSureDescription:
            "Werfen Sie einen Blick auf die Beispieldatensätze, um ein besseres Verständnis dafür zu bekommen, welche Probleme die unterschiedlichen Lernalgorithmen lösen.",
        ShowExamplesButton: "Beispiele anzeigen",
    },

    fileUpload: {
        Requirements: "Dateianforderungen",
        FileType: "Dateityp",
        FileSize: "Dateigröße",
        NumberRows: "Anzahl der Zeilen",
        NumberCols: "Anzahl der Spalten",
        Encoding: "Kodierung",
        EncodingValues: "UTF-8 oder ISO 8859-1",
        Formatting: "Formatierung",
        FirstRow: "Die erste Zeile muss Spaltennamen enthalten",
        EachCol: "Jede Spalte muss benannt sein",
        MultiIndexing: "⚠️ Keine Mehrfach-Indizierung",
        UploadCSVButton: "CSV-Datei hochladen",
    },

  hints: {
    CloseButton: "Schließen",
    NotYetProcessed: "Ihr aktuelles Experiment wurde noch nicht verarbeitet",
  },

    home: {
        Welcome: "Willkommen im KI-Lab.EE!",
        Goals:
            "Das KI-Lab.EE Tool dient dazu gängige maschinelle Lernverfahren mithilfe von AutoML (Automated Machine Learning) einfach und ohne die Verwendung von Code anzuwenden." +
            "                                               Dies ermöglicht einen Einstieg in das Thema Maschinelles Lernen unabhängig davon ob Programmierkenntnisse "+
            "                                               oder ein tieferes Vorwissen zum Thema vorhanden sind. \n" +
            "                                               Auf unserer Plattform können Sie ihrer eigenen Datensätze hochladen, Experimente durchführen, speichern und evaluieren." +
            "                                               Sie haben außerdem die Möglichkeit mithilfe unserer Beispieldatensätze einfache Anwendungsbeispiele auszuprobieren." +
            "                                               Zudem finden Sie einige Tutorials, welche Schritt für Schritt durch die einzelnen Schritte der Anwendung führen. ",
        TutorialExampleTitle: "Erkunden Sie unsere Beispiel-Datensätze.",
        TutorialExampleBody:
            "Wir haben eine Auswahl an vorgefertigten Experimenten für gängige Aufgaben wie Vorhersagen und Klassifizierung zusammengestellt. Sie können unser AutoML Tool anhand dieser Beispiele ausprobieren und die Vorteile kennenlernen.",
        TutorialDatasetTitle:
            "Laden Sie einen Datensatz hoch und erstellen Sie Ihr erstes Experiment.",
        TutorialDatasetBody:
            "Sie können einen tabellarischen Datensatz Ihrere Wahl hochladen und bekommen Schritt für Schritt die richtigen Informationen, wie Sie aus Ihrem Datensatz ein Experiment für maschinelles Lernen erstellen können." +
            " Unsere Plattform kann die Daten automatisch vorverarbeiten, analysieren und geeignete Modelle für Ihre Aufgabe vorschlagen.\n",

        TutorialExampleButton: "Beispieldatensätze anzeigen",
        TutorialDatasetButton: "Datensatz hochladen",
    },
    inspect: {
        PageTitle: "Experimentdaten prüfen",
        NumRows: "Anzahl der Zeilen",
        NumFeatures: "Anzahl der Eingangsdaten (Features)",
        NumTargets: "Anzahl der Zielwerte (Targets)",
        ValRatio: "Verhältnis Training /Validierung",
        TrainValSplitHint: "Der Datensatz wird in zwei Teile aufgeteilt: den Trainingsdatensatz, mit dem das Modell trainiert wird, und den Validierungsdatensatz, der verwendet wird, um die Vorhersagegenauigkeit zu überprüfen. " +
            "Auf diese Weise kann sichergestellt werden, dass das Modell gut auf neue, bisher ungesehene Daten generalisiert.",
        UseTestset: "Testdatensatz verwenden",
        ExplanationTestset:
          "Sie haben einen Testdatensatz für das Experiment hochgeladen",
        IsTimeseries: "Zeitreihendaten",
        ExplanationTimeseries:
          "Das bedeutet, dass Ihr Datensatz aufeinanderfolgende Zeitstempel enthält",
        IsSeasonal: "Saisonale Daten",
        ExplanationSeasonal:
          "Das bedeutet, dass Ihr Datensatz sich über mehr als ein Jahr erstreckt",
        TargetPlots: "Zielplots",
        TargetDropdown: "Ausgewählter Zielwert",
        HintTarget: "Wählen Sie das Zielattribut, das Sie inspizieren wollen", // TBD
        TargetOverTime: "Zielwert über die Zeit",
        TargetDistribution: "Zielwertverteilung",
        SeasonalDistribution: "Saisonale Verteilung",
        SeasonalDistributionXLabel: "Jahr",
        WarningPlots: "Diagramme zu Datensatzwarnungen",
  },
  range:{
         LoadRangeButton:"Placeholder",
        StartIndex:"Placeholder",
        EndIndex:"Placeholder",
        ResetButton: "Placeholder"
  },
  qualityCheck: {
      PageTitle: "Datenqualität des Experiments prüfen",
      ErrorTitle: "Schwerwiegender Fehler",
      ErrorsTitle: "Schwerwiegende Fehler",
      ErrorDescription: "Folgende schwerwiegende Fehler wurden in den Daten gefunden:",
      WarningTitle: "Warnung",
      WarningsTitle: "Warnungen",
      WarningDescription: "Folgender Aspekte der Daten könnte problematisch sein:",
      NoErrors: "Keine schwerwiegenden Fehler gefunden.",
      NoWarnings: "Alles sieht gut aus!",
      possibleProblems: "Mögliche Probleme sind:",
      colsWithImplausibleValuesText: " enthält auffällige Werte.",
      toManyCategoriesText: " enthält sehr viele Kategorien.",
      toManyNansText: " enthält zu viele Nan Werte.",
      constantColValuesText: "Eine oder mehr der Zielvariablen enthalten immer denselben Wert.",
      allFeaturesConstantText: "Alle Variablen enthalten dieselben Werte. " ,
      allTargetsConstantText: "Alle Zielvariablen enthalten jeweils nur einen Wert.",
      colsWithIntolerableManyCategoriesText: " enthält zu viele Kategorien. " ,
      colsWithImplausibleValuesDetails: "\n Die Werte weichen so stark von den anderen Werten in der Spalte ab, dass es auch unwahrscheinlich ist dass es sich um normale Ausreißer handelt." +
      "Es besteht die Wahrscheinlichkeit, dass es sich um fehlerhafte Werte handelt, die nocheinmal inspiziert werden sollten, da sie sonst das Modell negativ beeinflussn können.",
      toManyCategoriesDetails: "\n Zu viele Kategorien können je nach Datenstruktur und Modellart zu einer eingeschränkten Modellqualität führen.\n"+
      "\n",
      colsWithToManyCategoriesNumber: "\n Die Anzahl der Kategorien in der Spalte beträgt: ",
      allFeaturesConstantDetails:"\n Es ist nicht sinnvoll auf diesen Daten ein Modell zu trainieren. Es liegt vermutlich ein Fehler im Datensatz vor.",
      allTargetsConstantDetails: "\n Es ist nicht sinnvoll auf diesen Daten ein Modell zu trainieren. Es ist sehr wahrscheinlich, dass ein Fehler im Datensatz vorliegt. ",
      colsWithIntolerableManyCategoriesDetails: "\n Bei dieser Menge an Kategorien kann kein sinnvolles Modell berechnet werden. Es liegt vermutlich ein Fehler im Datensatz vor.",
      manyCategoriesProblems: " Dimensionalitätsproblem: \n" +
          " Mit jeder zusätzlichen Kategorie in einer Spalte erhöht sich die Anzahl der Dimensionen im Datensatz.\n" +
          " In hochdimensionalen Räumen benötigen viele Algorithmen wesentlich mehr Daten, um zuverlässige Vorhersagen zu treffen. \n" +
          "\n" +
          "Overfitting: \n" +
          " Ein Modell kann dazu neigen, sich zu sehr an die spezifischen Kategorien im Trainingsdatensatz anzupassen, wenn es zu viele gibt.\n" +
          " Dies kann dazu führen, dass das Modell gut auf den Trainingsdaten, aber schlecht auf neuen, unbekannten Daten generalisiert. \n" +
          "\n" +
          "Zeit- und Rechenressourcen:\n" +
          " Die Verarbeitung von Datensätzen mit vielen Kategorien kann sehr zeitaufwändig sein. Das Trainieren von Modellen,\n" +
          " die mit hochdimensionalen Daten arbeiten, erfordert oft leistungsstarke Hardware und kann lange dauern. \n" +
          "\n" +
          "Interpretierbarkeit: \n" +
          " Wenn eine Spalte viele Kategorien hat, kann es schwieriger sein, die Ergebnisse des Modells zu verstehen und zu interpretieren.\n" +
          " Es ist schwerer nachzuvollziehen, welche Kategorien einen starken Einfluss auf die Vorhersagen haben.\n" +
          "\n" +
          "Rauschen und Irrelevanz: \n" +
          " Es ist wahrscheinlicher, dass in einer Spalte mit vielen Kategorien auch irreführende oder rauschende Informationen enthalten sind,\n" +
          " die dem Modell schaden könnten. ",
      toManyNansProblems: "Informationsverlust: \n" +
          " Der Informationsrad, den die Spalte enthält ist eingeschränkt. Wenn zu viele Werte in einer Spalte fehlen, \n" +
          "geht potenziell wichtiges Wissen verloren.\n" +
          "                                                                \n" +
          "Verzerrung der Analyse und Vorhersagen:\n" +
          " Fehlende Werte können dazu führen, dass statistische Analysen verzerrt werden. Das betrifft auch Machine Learning Modelle, \n" +
          " da sie Schwierigkeiten haben könnten, aussagekräftige Muster zu erkennen, wenn zu viele fehlende Werte innerhalb einer Spalte vorhanden sind.",
      constantColValuesProblems: "Mangel an Information:\n" +
          " Ein konstantes Ziel liefert keine nutzbringenden Informationen für die Modellierung. Es trägt nicht zur Verbesserung der \n" +
          " Vorhersagen bei. Wenn ein Ziel immer denselben Wert hat, liefert es dem Modell keine Variabilität oder Informationen zur Unterscheidung zwischen \n" +
          " verschiedenen Eingaben.",
  },
    login: {
        PageTitle: "Zugangsnamen für Demonstrator festlegen",
        Description:
            "Ihr Zugang zum AutoML MDZ Demonstrator wird durch einen einzigartigen Namen festgelegt. Falls Sie den Demonstrator noch nicht verwendet haben, notieren Sie sich den hier vorgeschlagenen Namen und klicken Sie auf Speichern. \n" +
            "Falls Sie bereits einen Zugangsnamen haben, geben Sie Ihn bitte anstatt dem hier vorgeschlagenen Namen ein und klicken Sie ebenfalls auf speichern",
        UidFillable: "Ihr Zugangsname",
        SaveButton: "Zugangsname für Demonstration speichern",
    },

    overview: {
        MyDatasetsTitle: "Meine Datensätze",
        MyDatasetsSubTitle:"Verwalte deine Datensätze und Experimente an einem Ort",
        MyExperimentsTitle: "Meine Experimente",
        DataButton: "Neuen Datensatz hinzufügen",
        ExperimentButton: "Neues Experiment hinzufügen",
        DeleteDatasetButton: "Ausgewählten Datensatz löschen",
        DeleteExperimentButton: "Ausgewählte Experimente löschen",
        DeleteDatasetWarning: "Sie sind dabei diesen Datensatz und alle dazugehörigen Experimente zu löschen. Möchten Sie fortfahren?",
        DeleteExperimentWarning: "Sie sind dabei alle ausgewählten Experimente zu löschen. Möchten Sie fortfahren?",
        DeleteRunWarning: "Sie sind dabei diesen Trainingslauf und das dazugehörige Modell zu löschen. Möchten Sie fortfahren?",
        Experiments:"Experimente",
        NoExperiments:"Keine Experimente verfügbar",
        NoDatasets:" Keine Datensätze verfügbar",
        NoExperimentsMessage:" Noch keine Experimente. Erstellen Sie Ihr erstes Experiment, um loszulegen!",
        AddSplitButton: "Split-Datei hinzufügen",
        NoSplitFile: "Noch keine Split-Dateien angelegt",
        UploadSplitFileText: " Laden Sie eine CSV Datei hoch um einen neuen Split zu erstellen",
        SplitFilesTitle: "Daten für Validations- und Testsetsplits",
        DeleteSplitFileButton: "Split-Datei löschen",
        DeleteSplitFileWarning: "Sind sie sicher, sie möchten diese Split-Datei löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
        Actions:"Aktionen",


    },
    splitData: {
        SuccessMessage: "Split-Dateien erfolgreich hochgeladen.",
        ReadyToConfigure: "Konfiguration des Experiments ist jetzt möglich.",
        CreateSplitsTitle:"Benutzerdefinierter Validationsdatensatz für: {{datasetName}}\"",
        AvailableFields: "Benötigte Spalten",
        DragAndDropCSVFile:"CSV-Datei per Drag & Drop ablegen oder zum Durchsuchen anklicken",
        DropYourCSVFileHere:"CSV-Datei hier ablegen",
        SupportsCSVFiles: "CSV Daten bis zu 50MB erlaubt",
        CustomFileName: "Benutzerdefinierter Dateiname (optional)",
        CustomFileNamePlaceholder: "Hier benutzerdefinierter Dateiname eingeben",
        Uploading: "Lädt hoch...",
        UploadSplitDataset: "Split-Datensatz hochladen",
        UploadedSplitFiles: "Split-Datensatz wurd hochgeladen",
        UploadCompletedSuccessfully:"Alle Uploads erfolgreich abgeschlossen",
        PreviewOfSplitData: "Datensatz Vorschau",
        ShowingFirst10Rows: "Ansicht der ersten 10 Zeilen",
        YouCanUploadMultipleFiles: "Es kann jeweils eine Datei hochgeladen werden. Um weitere Dateien hinzuzufügen, klicken Sie auf „Datenübersicht",
        CustomFileNameError:"Der Dateiname darf kein '.csv', enthalten. Die Endung wird automatisch hinzugefügt.",
    },

    processingStatus: {
        PageTitle_1: "Ihr Experiment",
        PageTitle_2: "wird gerade verarbeitet.",
        Description:
            "Die folgenden Schritte werden derzeit durchgeführt. Je nach Größe Ihres Datensatzes kann dies bis zu 10 Minuten dauern.",
        LabelConstants: "Überprüfung der Daten auf konstante Spalten",
        DescriptionConstants:
            "In diesem Schritt wird der Datensatz auf seine inhaltliche Konsistenz überprüft. " +
            "                                                   Gibt es Zeilen, in denen immer nur derselbe Wert eingetragen ist, \n" +
            "                                                   bietet diese keinerlei verwertbare Informationen für das Training des Maschine Learning Modells " +
            "                                                   und ist außerdem ein Hinweis auf einen Fehler bei der Datenerfassung. " +
            "                                                   Aus diesen Gründen werden solche Daten aus dem Datensatz entfernt. ",
        LabelOneHot: "Überprüfung der Daten für One-Hot-Encoding",
        DescriptionOneHot:
            "In diesem Schritt werden kategorische Daten in numerische Daten umgewandelt, " +
            "                                                   um die Daten in eine Form umzuwandeln, welche von maschinellen Lernalgorithmen verstanden werden kann. \n" +
            "                                                   Dabei wird jede Kategorie in eine eigene Spalte umgewandelt, und es wird eine 1 in der entsprechenden Spalte gesetzt, " +
            "                                                   wenn die Kategorie zutrifft, andernfalls wird eine 0 gesetzt. Das Ergebnis ist eine binäre Darstellung der Kategorien, \n " +
            "                                                   bespielsweise werden die kategorischen Daten \"rot\", \"blau\" und \"grün\" durch das One-Hot-Encoding zu [1,0,0] für \"rot\", " +
            "                                                   [0,1,0] für \"blau\" und [0,0,1] für \"grün\".",
        LabelNormalize: "Normalisierung der Daten",
        DescriptionNormalize:
            "In diesem Schritt werden die im Datensatz enthaltenen numerischen Daten in einen einheitlichen Bereich, " +
            "                                                   wie z.B. zwischen 0 und 1, skaliert. Dieser Schritt wird durchgeführt um die Unterschiede in den " +
            "                                                   Maßeinheiten der einzelnen Features auszugleichen, was die Vergleichbarkeit der Features und damit die Leistung der Algorithmen verbessert. ",
        LabelMissingValues: "Ersetzen fehlender Werte in den Eingangsdaten",
        DescriptionMissingValues:
            "KI-Modelle wie neuronale Netze können keine fehlenden Daten (NaN-Werte) in den Eingangsdaten verarbeiten. " +
            "                                                   Das Ersetzen fehlender Werte ist daher ein entscheidender Schritt in der Datenverarbeitungsphase, " +
            "                                                   um solche fehlenden Daten zu behandeln. Dies kann entweder durch das Entfernen oder das Ersetzen der fehlenden Werte erfolgen. \n " +
            "                                                   Beim Ersetzen der Werte wird mit statistischen Methoden wie Mittelwert, Median oder Modus gearbeitet. " +
            "                                                   Die Wahl der Methode hängt von der Menge der fehlenden Daten und der Art der Eingangsvariable ab.",
        LabelAnomalies: "Überprüfung der Daten auf typische Anomalien",
        DescriptionAnomalies:
            "In diesem Schritt wird der Datensatz auf Anomalien untersucht. Dabei werden mögliche Ausreißer identifiziert, " +
            "                                                   die Daten auf Normalverteilung geprüft, sowie mögliche Messfehler identifiziert.\n " +
            "                                                   Dieser Schritt ist wichtig um sicherzustellen, dass die später generierten Modelle nicht durch Anomalien in den Daten verfälscht werden. " +
            "                                                   Eine detailiertere Aufschlüsselung der gefundenen Anomalien und Auffälligkeiten können Sie im Punkt „Daten inspizieren“ finden. ",
        ReadNextButton: "Weiterlesen",
        BackButton: "Zurück",
        CompletedMessage: "Alle Schritte abgeschlossen - Sie sind fertig!",
        ProceedButton: "Mit der Experimentbearbeitung starten",
    },

  sidebar: {
    DemoNotification:
      "Die aktuelle Version des AutoML MDZ Tools dient lediglich zu Demonstrationszwecken. \n Weitere Features zum Starten von eigenen Trainings etc. sind in Bearbeitung und werden in Kürze hinzugefügt.",
    UseCasesButton: "Beispieldatensätze",
    DataExplorerButton: "Datensatz Explorer",
    CurrentExperimentButton: "Experiment & Analyse",
    DataQualityButton: "Datenqualität prüfen",
    InspectButton: "Daten Inspizieren",
    ConfigureButton: "Training Durchführen",
    AnalyseButton: "Ergebnisse Analysieren",
    CompareButton: "Läufe Vergleichen",
    OngoingButton: "Laufende & geplante Läufe",
    MyDatasetsButton: "Datenübersicht",
    ScheduledAndRunningButton: "Geplant & Laufend",
    NoRunsInfo: "Keine aktuellen Trainings",
    Export: "KI-Modell exportieren",
    MyAccountButton: "Mein Account",
    MyAccountInfo: "Account Info",
    MyAccountLogout: "Logout",
    AboutFunding: "Ein Projekt von:",
    AboutLink: "Über das KI-Lab.EE",
    PrivacyLink: "Datenschutz",
    ImprintLink: "Impressum",
    Copyright: "ZSW © 2026",
    ShowFailedRunCheckBox:"Fehlgeschlagene Läufe anzeigen",
    RerunButton: "Neu Starten",
    Language:"Sprache",
    CheckboxMessage: "Alle Läufe sind fehlgeschlagen. Aktivieren Sie das Kontrollkästchen Fehlgeschlagene Läufe anzeigen, um sie anzuzeigen.",
  },

    languageSelector: {
        Label: "Sprache",
        Title: "Wählen Sie eine Sprache",
    },

    runs: {
        PageTitle: "Läufe für dieses Experiment",
        Results: "Ergebnisse",
        NoExperiments:
            "Ihr aktuelles Experiment verfügt über keine trainierten Modelle, die verglichen werden können. \n Sie können eine ",
        NoExperiments_LinkText: "Trainings-Pipeline",
        NoExperiments_AfterLink: " starten, um ein trainiertes Modell zu erhalten.",
        AEValPlotTitle: "Absoluter Fehler Validations Set",
        AETrainPlotTitle: "Absoluter Fehler Trainings Set",
        AccuracyValPlotTitle: "Accuracy Validations Set",
        AccuracyTrainPlotTitle: "Accuracy Trainings Set",
        AccuracyPlotYLabel: "Accuracy",
        AccuracyPlotXLabel: "Klasse",
    },

    trainer: {
        TitleRunCreation: "Neuen Trainingslauf erstellen oder bestehenden erweitern",
        TitleTrainingConfiguration: "Konfigurieren und Ausführen eines Modell-Trainingslauf",
        TitleExtendRun: "Bestehenden Trainingslauf erweitern",
        DropdownOptiMethod: "AutoML-Optimierungsmethode",
        HintOptiMethod:
            "Die AutoML-Methoden zur automatischen Optimierung der Hyperparameter Ihres Modells", // TBD
        DataBalancingTitle: "Zielwert-Balancierung",
        DropdownBalancerMethod: "Zielwert-Balancierungsmethode",
        SelectedNoDataBalancer: "Keine Balancierung",
        HintBalancerMethod: "Die Methode zur Ausbalancierung des Datensatzes wird nur bei unausgewogenen Datensätzen benötigt. Ein Datensatz ist unausgewogen, wenn der Zielwert nicht gleichmäßig verteilt ist.",
        DropdownRunsLabel: "Ausgewählter Trainingslauf",
        DropdownRunsNew: "Neuer Trainingslauf",
        HintDropdownRuns: "Erstellen Sie einen neuen Trainingslauf oder wählen Sie einen abgeschlossenen Lauf um diesen zu erweitern.",
        InputRunName: "Laufname",
        HintRunName: "Der Name dient der Übersicht und ist frei wählbar",
        PageDescription: "KI-Modelltyp auswählen",
        HintModelType:
            "Wählen Sie den Modelltyp, der am Besten zu Ihrer Aufgabe passt", // TBD
        RunNameNotEmpty:"Der Laufname darf nicht leer sein",
        RunNameForbiddenPattern:"Der Laufname darf keine der folgenden Zeichen enthalten {{forbiddenPattern}}\"",
        TitleLSTMNetwork: "Long Short-Term Memory (LSTM)",
        DescriptionLSTMNetwork: "Ein spezieller Algorithmus, der gut darin ist, Zusammenhänge in zeitlichen Daten zu verstehen. Damit ist er vor allem gut darin Muster in Daten mit zeitlichen Abhängigkeitwn zu erkennen." +
            "Da der LSTM über eine Art Gedächtnis verfügt ist er in der Lage Strukturen in Zeitreihen zu erkennen, die sich über einen längeren Zeitraum erstrecken.",
        QualityLSTMNetwork: 5,
        SpeedLSTMNetwork: 2,
        TitleRandomForest: "Random Forest",
        DescriptionRandomForest: "Ein Algorithmus des überwachten Maschinellen Lernens, welcher mehrere zufällig gewählte Entscheidungsbäume zu einem Wald zusammenstellt. " +
            "                       Er eignet sich für eine Vielzahl von Anwendungsfällen und ist für viele verschiedene Arten von Datenstrukturen geeignet.",
        QualityRandomForest: 4,
        SpeedRandomForest: 5,
        TitleNeuralNetwork: "Neuronales Netzwerk",
        DescriptionNeuralNetwork: "Ein Algorithmus des überwachten Maschinellen Lernens, welcher die Struktur des menschlichen Nervensystems nachempfunden ist. " +
            "                       Die Daten werden durch mehrere miteinander vernetzte künstliche Neuronen geleitet. " +
            "                       Neronale Netze eigenen sich vor allem für Aufgaben in denen komplexe Muster oder Beziehungen in den Daten erkannt werden sollen",
        QualityNeuralNetwork: 5,
        SpeedNeuralNetwork: 2,
        TitleGaussianProcess: "Gauß-Prozess",
        DescriptionGaussianProcess: "Ein Nicht-parametrischer bayesischer Algorithmus, der aus dem bereich der stochastischen Prozesse und Wahrscheinlichkeitstheorie kommt. " +
            "                       Das Verfahren eignet sich vor allem bei einer begrenzten oder unvollständigen Datenmenge.",
        QualityGaussianProcess: 4,
        SpeedGaussianProcess: 4,
        TitleGaussianMixtureNeuralNetwork: "Probabilistisches Neuronales Netzwerk",
        DescriptionGaussianMixtureNeuralNetwork: "Ein Neuronales Netz, das anstatt eines Wertes, die Parameter einer Gaußmischverteilung vorhersagt.",
        QualityGaussianMixtureNeuralNetwork: 4,
        SpeedGaussianMixtureNeuralNetwork: 1,
        TitleTabPFN: "TabPFN",
        DescriptionTabPFN: "TabPFN ist ein Foundation Model für tabellarische Daten. Dieses Modell benötigt minimalen Trainingsaufwand (🌿 zero-shot learning) und ist sehr gut für eine erste Einschätzung oder Datensätze mit wenig Daten geeignet",
        QualityTabPFN: 3,
        SpeedTabPFN: 5,
        TitleAFS: "Automatische Feature Selection*",
        TitleAdditionalHPO: "Zusätzlich Hyperparameteroptimierung durchführen",
        DescriptionAFS: "Zusätzlich zur Modell-Hyperparametersuche wird ein Algorithmus eingesetzt, der automatisch optimale Features für das Modelltraining auswählt. "+
            "Dies ist empfehlenswert bei einer großen Anzahl von Features oder wenn festgestellt werden soll, welche Features für die Problemlösung vernachlässigbar sind. " +
            "Die Auswahl dieser Option verlängert jedoch nicht nur den Rechenaufwand, sondern auch die Gesamttrainingszeit. ",
        TitlePipelineSteps: "Zusätzliche Pipeline-Optionen für das Training",
        HintPipelineSteps: "Abhängig vom gewählten Modelltyp können hier zusätzliche Schritte für die Trainings-Pipeline ausgewählt werden",
        HintCanBeExecutedLater: "* Kann auch später, nach dem Training ausgeführt werden",
        ExpectedQuality: "Erwartete Modellqualität",
        ExpectedSpeed: "Erwartete Trainingsgeschwindigkeit",
        SliderNumTrials: "Anzahl der zu testenden Modelle",
        HintNumTrials:
            "Wählen Sie die Anzahl der Durchläufe für die Hyperparameteroptimierung", // TBD
        AdvancedOptions: "Erweiterte Optionen",
        OptimizationConfigTitle: "Optimierungskonfiguration",
        HintOptimizationConfig: "⚠️ Experten-Feature! Hier können die Einstellungen der Hyperparameteroptimierung für das gewählte Modell konfiguriert werden. \n Parameter, die nicht mit 'optimize' markiert sind, werden in jedem Training mit dem Wert 'init' verwendet.",
        HyperParamsPiplineStepsTitle: "Konfiguration des Pipeline-Schritts: ",
        HeaderType: "Typ",
        HeaderScale: "Skalierung",
        StartButton: "Starte Trainings-Pipeline",
        SuccessPipelineStarted: "Trainingslauf erfolgreich gestartet",
        ErrorRunAlreadyExists:
            "Ein Lauf mit diesem Namen existiert bereits  \n für dieses Experiment. Bitte wählen Sie einen anderen Namen.",
        AddDefaultHyperparameter: "Standard-Hyperparameter hinzufügen",
        SelectDefaultHyperparameter:"Standard-Hyperparameterset auswählen",
        EnterHyperparameterName:"Name der Hyperparameter-Konfiguration",
        Save:"Speichern",
        DeleteDefaultHyperparameterWarning:"Möchten Sie den Standard-Hyperparameter wirklich löschen",
        ExtendRunButton:"Erweitern",
        ErrorNumTrialsTooSmall:"Es müssen mindestens so viele Trainings angegeben werden wie bereits durchgeführt wurden ({{previous}} Stück)",
        ConfirmExtendSameTrials: "Es sind genau gleich viele Trainings angegeben wie durchgeführt wurden. In diesem Fall wird nur die Auswertung neu gestartet",
        HintExtendNumTrials: "Hier angezeigt ist die Gesamtanzahl der Trainings, nicht die Menge um die erweitert wird",
        RunExtendFailed: "Erweiterung des Trainings fehlgeschlagen",
        SendEmailOnTrainingFinish:"Mail senden wenn das Training abgeschlossen ist",
        HintSendEmail:"Klicke hier, um deine Benachrichtigungs E-Mail-Adresse in den Kontoeinstellungen zu aktualisieren",
        SendEmaiOnExperimentFinish:"E-Mail senden wenn die Vorverarbeitung abgeschlossen ist.",

    },

    pipelineStatus: {
        PageTitle: "Status der Trainings-Pipeline",
        PageDescription:
            "Folgende Schritte gehören zu der Pipeline des aktuellen Trainingslauf.",
        InitializingInfo: "Die Trainings-Pipeline wird initialisiert. \n Bevor der eigentliche Prozess beginnt, wird Ihr Auftrag in eine Warteschlange eingereiht, um auf den Servern ausgeführt zu werden. Abhängig von der Auslastung der Server kann es eine gewisse Wartezeit geben, bevor die Berechnung beginnt.",
    },
    trainingStatus: {
        PageTitle: "Status des HPO Trainings",
        PageDescription:
            "Folgende Schritte werden derzeit durchgeführt. Die Trainingsdauer ist abhängig von der Größe Ihres Datensatzes und der Problemstellung.",
        TitleInfoBox: "Informationen zum Modelltraining",
        ModelTypeTitle: "Modelltyp",
        NumTrainTitle: "Maximale Anzahl an Trainings",
        DatasetInfoBox: "Datensatzinformationen",
        ValRatioInfoTitle: "Trainings- / Validierungsverhältnis",
        DescriptionValRatio:
            "Verhältnis zwischen Trainings- und Validierungsdatensatz",
        TestsetInfoTitle: "Testdatensatz verwenden",
        DescriptionTestset:
            "Sie haben einen Testdatensatz für das Experiment hochgeladen",
        TimeInfoBox: "Zeitinformation",
        TimeseriesInfoTitle: "Ist Zeitreihendaten",
        DescriptionTimeseries:
            "Das bedeutet, dass Ihr Datensatz aufeinanderfolgende Zeitstempel enthält",
        SeasonalInfoTitle: "Ist saisonale Daten",
        DescriptionSeasonal:
            "Das bedeutet, dass Ihr Datensatz über mehr als ein Jahr erstreckt",
        PipelineStepProgressTitle: "Fortschritt des aktuellen Schritts",
        TrainingStepDescriptions: "Erklärung und Status der Trainingsschritte",
        LabelStep1: "Hyperparameter Initialisierung",
        LabelStep2: "Hyperparameteroptimierung und Modell-Training",
        LabelStep3: "Training abschließen und Modell speichern",
        LabelStep4: "Diagramme erstellen und Metriken berechnen",
        DescriptionStep1:
            "Im ersten Schritt wird ein initiales Hyperparameterset für das gewählte KI-Modell gesetzt. " +
            "Dabei wird entweder das zuvor definierte Hyperparameterset verwendet oder es wird abhängig vom Modell ein Set innerhalb bestimmter Parameter definiert.",
        DescriptionStep2:
            "In diesem Schritt findet eine Optimierung der Hyperparameter auf den vorliegenden Use-Case statt. " +
            "                                                   Dazu wird das Modell trainiert und anschließend wird mittels eines Validierungsdatensatzes die Modellqualität beurteilt. " +
            "                                                   Mithilfe der ermittelten Modellqualität ist dann ein Optimierungsalgorithmus in der Lage die Hyperparameterauswahl "+
            "                                                   für das nächste Training zu verbessern. Dieser Prozess wird solange iterativ durchgeführt, bis die gewählte Anzahl an Trainings erreicht wurde, aus diesem Grund benötigt dieser Schritt auch einige Zeit.",
        DescriptionStep3:
            "Nach der Durchführung der vorgegebenen Trainingsanzahl wird der Trainingsprozess abgeschlossen. " +
            "                                                   Das Modell wird nun gespeichert, um für künftige Vorhersagen wiederverwendet oder auf neue Daten feinabgestimmt zu werden. " +
            "                                                   Das gelernte Modell sowie die Vorverarbeitungspipeline werden später im ONNX Dateiformat als Download verfügbar sein. ",
        DescriptionStep4:
            "Im letzten Schritt wird die Leistung des Modells bewertet. Je nach Modell eignen sich dazu sowohl visuelle als auch numerische Beurteilungskriterien. " +
            "                                                   In diesem Schritt wird eine Reihe geeigneter qualitativer und quantitativer Metriken erstellt. " +
            "                                                   Anhand dieser Metriken können verschiedene Modelle verglichen werden, um das geeignetste Modell für das vorliegende Problem auszuwählen. ",
        ReadNextButton: "Weiterlesen",
        BackButton: "Zurück",
        CompletedMessage: "Alle Schritte abgeschlossen - Sie sind fertig!",
        ViewingCompletedPipeline: "Sie sehen gerade eine abgeschlossene Pipeline. Klicken Sie auf einen beliebigen Schritt, um die Ergebnisse zu analysieren.",
        NavigationMessage: " Das ist die Ansicht des Pipeline-Steps:",
        TrainingPlotsTitle: "HPO Visualisierung",
        ProceedButton: "Weiter zu den Ergebnissen",
                // These are all related to the run status
            StatusTitle: "Status Trainings-Pipeline:",
            Initializing: "Initialisierung",
            RUNNING: "Aktiv",
            NotRunning: "Not Running",
            Paused: "Paused",
            Completed: "Run Completed",
            FAILED: "Fehlgeschlagen",
            CANCELLED: "Cancelled",
        FINISHED: "Fertig",
            Undefinied: "Unbekannt",
        OptimizerResults: "Aktuelle Ergebnisse der Hyperparameteroptimierung",
        ResetPlotViewButton: "Plot-Einstellungen zurücksetzen",
        ShowBestEpochButton: "Beste Epoche visualisieren",
        BestEpoch: "Beste Optimierer-Epoche",
        BestSoFar: "Bester Wert",
        OptimizerEpoch: "Optimierer-Epoche",
        Metric: "nRMSE",
        Trial: "Getesteter Wert",
        Parcoord: "Hyperparameter-Kombinationen",
        CancelTrainingButton: "Training abbrechen",
        HintCancelTraining: "Dies stoppt den Trainingsprozess und löscht den Lauf.",
        FinalizeTrainingButton: "Training abschließen",
        HintFinalizeTraining: "Dies beendet den Optimierungsprozess frühzeitig so reibungslos wie möglich. Dies erfordert das Abschließen der aktuellen Generation. Es speichert das Modell und erstellt die Diagramme. Dies kann einige Zeit in Anspruch nehmen.",
        CancelConfirmationMessage: "Sind Sie sicher, dass Sie das Training abbrechen möchten?",
        ConfirmCancelButton: "Ja, abbrechen",
        CancelButton: "Abbruch abbrechen",
        CancelConfirmationTitle: "Bestätigung des Trainingsabbruchs",
        HintFinalizeTrainingButton: "Dies beendet den Optimierungsprozess so früh wie möglich ohne Fehler zu erzeugen. Dies erfordert den Abschluss der aktuellen Generation. Danach wird das Modell gespeichert und die Diagramme erstellt. Dies kann einige Zeit dauern.",
        HintCancelTrainingButton: "Dies stoppt den Trainingsprozess und löscht den Lauf.",
        FinalizeConfirmationTitle: "Bestätigung der Trainingsfinalisierung",
        FinalizeConfirmationMessage: "Sind Sie sicher, dass Sie das Training finalisieren möchten?",
        ConfirmFinalizeButton: "Ja, finalisieren",
        FinalizeButton: "Finalisierung abbrechen",
        SelectedHyperparameterRanges: "Ausgewählte Hyperparametersuchbereiche",
        SelectedBalancingSetting:"Balancing Daten",
        ParameterLabel:"Parameter Name",
        ValueLabel:"Parameter Wert",
        NoBalancingOptions:"Keine Balancing-Optionen konfiguriert",

    },
    AFSTrainingStatus: {
        PageTitle: "Status der Automatischen Feature Selektion (AFS)",
        PageDescription:
            "Es werden mehrere Trainings zur AFS durchgeführt. Die Trainingsdauer ist abhängig von der Größe Ihres Datensatzes und der Problemstellung.",
        DescriptionSelectedFeatures: "Darstellung der ausgewählten Features.",
        DescriptionLossCurve: "Darstellung des Fehlerverlaufs.",
        HeatmapColorBarLabel: "Feature Status",
        HeatmapColorMax: "Selektiert",
        HeatmapColorMin: "Nicht Selektiert",
        HeatmapTitle: "Selektierte Features pro Trainingsdurchlauf",
        HeatmapXTitle: "Trainingsdurchlauf",
        HeatmapYTitle: "Features",
        ScatterTitle: "Fortschritt Fehler und Anzahl Features",
        ScatterIntersectLabel: "Intersektion",
        ScatterRobustLabel: "Robust",
        ScatterXAxisLabel: "Trainingsdurchlauf",
        ScatterYAxis1Label: "Fehler (nRMSE)",
        ScatterYAxis2Label: "Anzahl der selektierten Features",
    },

    tour: {
        BeaconTooltip: "Starte das Tutorial",
        AddDatasetButton: "Als erstes müssen Sie einen neuen Datensatz hinzufügen",
        CurrentDatasetSelector:
            "Wenn Sie mehrere Datensätze hochgeladen haben, können Sie hier einen auswählen",
        AddExperimentButton:
            "Nachdem Sie einen Datensatz ausgewählt haben, können Sie für diesen ein neues Experiment erstellen. Verschiedene Experimente dienen dazu unterschiedliche Trainings mit dem gleichen Datensatz durchzuführen und diese zu vergleichen",
        CurrentExperimentSelector:
            "Wenn Sie mehrere Experimente für einen Datensatz erstellt haben, können Sie hier eines auswählen",
        CurrentExperimentProgress:
            "Hier können Sie den aktuellen Fortschritt ihres momentan ausgewählten Experimentes sehen, d.h. die Daten inspizieren, ein Training starten, etc.",
        NextButton: "Weiter",
        BackButton: "Zurück",
        SkipButton: "Überspringe Tutorial",
    },

    about: {
        Header: 'Über das AutoML KIlab.EE Tool',
        KilabDescription: "Das AutoML KIlab.EE Tool ermöglicht es die Vorteile von AutoML interaktiv zu  vermitteln und eigene Use-Cases zu kreieren. Das AutoML Tool steht kostenlos zur Verfügung und wurde für Unternehmen aus dem deutschen Klein- und Mittelstand konzipiert.",
        KndHeader: 'Was ist AutoML und wie nutzt es dem Klein- und Mittelstand?',
        KndDescription: 'Automated Machine Learning (AutoML) ist ein aufstrebendes Konzept und beschäftigt sich damit, die Anwendung von maschinellem Lernen so weit es möglich ist zu Automatisieren. Bei der manuellen Anwendung von KI bzw. Maschinellem Lernen fallen viele Schritte an, welche Expertise im KI-Kontext erfordern.\n\n' +
            'Beispielsweise: \n ' +
            '- Datenvorverarbeitung: KI-Modelle können nicht jede Art von Daten gleich gut verarbeiten. Aus diesem Grund ist es wichtig, die KI-Modelle zu kennen und zu wissen, welche Vorverarbeitungsschritte notwendig sind um die Daten ideal für das Modell-Training vorzubereiten. \n' +
            '- Modellauswahl: Die Auswahl welches KI-Modell sich für eine Problemstellung am Besten eignet ist nicht trivial. Abhängig von den Daten, der Art und der Komplexität des Problems müssen unterschiedliche KI-Modelle gewählt werden. \n' +
            '- Hyperparameterauswahl: Jedes KI-Modell-Training kann mit diversen Hyperparametern eingestellt werden. Zum Beispiel die Anzahl der Neuronen in einem neuronalen Netz. Wie diese für einen Datensatz gewählt werden müssen, erfordert lange Erfahrung mit KI-Modellen. \n' +
            'AutoML möchte diese Schritte weitesgehend automatisieren. Das nimmt nicht nur KI-Fachkräften zeitaufwändige Arbeit ab, sondern ermöglicht es Personen bzw. Unternehmen mit wenig KI-Expertise, vollwertige KI-Applikationen zu erschaffen, ohne eine Zeile Code.',
        ConceptHeader: 'Welche Konzepte stecken hinter AutoML und wie wird es in diesem Tool genutzt?',
        ConceptDescription: 'AutoML ist ein komplexes Forschungsgebiet in dem das gesammelte Wissen der letzten Jahrzehnte KI-Anwendung einfließt. Einfach ausgedrückt werden für die Automatisierung verschiedene vordefinierte Regeln und Optimierungsalgorithmen verwendet.\n\n ' +
            'Das AutoML KIlab.EE Tool hat das Ziel die Komplexität von AutoML erklärbar zu machen und interaktiv Einblicke in die Funktionsweise zu geben. Während der Nutzung des Tools stehen Ihnen immer wieder Erklärungshinweise zur Verfügung um zu sehen, wo und wie AutoML eingesetzt wird.',
        Promotion: 'Förderung',
        PromotionDescription: "\nDer Aufbau, die kontinuierliche Weiterentwicklung und Betreuung des KI-Lab.EEs wurden durch folgende Förderprojekte ermöglicht:",
        MdzHeader: 'Was ist Mittelstand-Digital?',
        MdzDescription: 'Das Mittelstand-Digital Netzwerk bietet mit den' +
            '                            Mittelstand-Digital Zentren, der Initiative IT-Sicherheit in der' +
            '                            Wirtschaft und Digital Jetzt umfassende Unterstützung bei der' +
            '                            Digitalisierung. Kleine und mittlere Unternehmen profitieren von' +
            '                            konkreten Praxisbeispielen und passgenauen, anbieterneutralen' +
            '                            Angeboten zur Qualifikation und IT-Sicherheit. Das' +
            '                            Bundesministerium für Wirtschaft und Klimaschutz ermöglicht die' +
            '                            kostenfreie Nutzung und stellt finanzielle Zuschüsse bereit.' +
            '                            Weitere Informationen finden Sie unter www.mittelstand-digital.de',
        Contact: 'Kontakt',
        ContactQuestions: 'Bei Rückfragen oder anderem Feedback wenden Sie sich gerne an'
    }
};

translationDE.demo = demo;
export default translationDE;
